export default {
  // General
  'About {appName}': '{appName}:sta',
  'About Enable Banking API': 'Enable Banking API:sta',
  'Application description is not provided.': 'Sovelluksen kuvausta ei toimiteta.',
  'Authenticate': 'Tunnistaudu',
  'Authentication method': 'Todennus tapa',
  'Authentication session has expired': 'Istunto on vanhentunut',
  'Cancel': 'Peruuta',
  'Click {0} button if you have confirmed authorization in the BankID app.': 'Paina {0} painiketta, jos olet vahvistanut valtuutuksen BankID-sovelluksessa.',
  'Continue authentication': 'Jatka tunnistautumista',
  'Cookies must be enabled in your browser to continue': 'Jatkaaksesi evästeiden on oltava käytössä selaimessasi',
  'Enter your OTP code with index {0}': 'Anna avaintunnusta {0} vastaava turvaluku',
  'Error during authentication:': 'Virhe tunnistautumisen aikana:',
  'Error while updating authentication status': 'Virhe päivitettäessä tunnistautumisen tilaa',
  'OTP code': 'Turvaluku',
  'Open the BankID app on this device': 'Avaa BankID-sovellus tällä laitteella',
  'Redirecting to your account servicing provider': 'Uudelleenohjaus tilitietopalveluntarjoajaan',
  'Returning to the authentication initiator': 'Palataan tunnistautumisen aloittajalle',
  'Start the BankID app on your mobile device and tap the QR code button in the app to scan the QR code on this page': 'Käynnistä BankID-sovellus mobiililaitteellasi ja paina sovelluksen QR-koodi -painiketta skannataksesi tällä sivulla oleva QR-koodi',
  'or': 'tai',
  'Starting authorization': 'Aloitetaan tunnistautuminen',
  'To continue please use your authentication app': 'Jatka käyttämällä tunnistautumissovellustasi',
  'Try again': 'Yritä uudelleen',
  'Submit': 'Lähetä',
  'Unable to access server': 'Palvelinta ei voi käyttää',
  'Unable to authenticate': 'Tunnistautuminen epäonnistui',
  'Unable to continue authorization': 'Valtuutusta ei voi jatkaa',
  'Unable to continue decoupled authorization': 'Irrotettua tunnistusta ei voida jatkaa',
  'Unable to handle authentication status "{status}"': 'Tunnistustilaa "{status}" ei voida käsitellä',
  'Unknown error occurred': 'Tapahtui tuntematon virhe',
  'You need to close this window': 'Sinun on suljettava tämä ikkuna',
  'Authentication cancelled': 'Todennus peruutettu',
  // Consent
  'Authentication is initiated by {0}.': 'Tunnistautumisen suorittaa {0}.',
  'After you complete authentication, {0} will be shared with the authentication initiator.': 'Kun olet suorittanut tunnistautumisen, {0} tullaan jakamaan tunnistautumisen suorittajan kanssa.',
  'your payment accounts data': 'maksutilisi tieto',
  'the list of your payment accounts': 'lista maksutileistä',
  'the list of your payment accounts and accounts balances': 'lista maksutileistä ja tilien saldot',
  'the list of your payment accounts and accounts transactions': 'lista maksutileistä ja tilitapahtumat',
  'the list of your payment accounts, accounts balances and transactions': 'lista maksutileistä, tilien saldot ja tilitapahtumat',
  'By pressing {0} button you agree with the {1}.': 'Painamalla {0} painiketta hyväksyt samalla {1}.',
  'Press {0} button if you are not willing to share your payment accounts data.': 'Paina {0} painiketta jos et halua jakaa, maksutilisi tietoja.',
  // Payment consent
  'Payment details': 'Maksutiedot',
  'Payment ID provided by the application: {0}': 'Sovelluksen antama maksutunnus: {0}',
  'Account number where to transfer funds: {0}': 'Tilinumero, johon varat siirretään: {0}',
  'Payee name in the payment: {0}': 'Maksunsaajan nimi maksussa: {0}',
  'Payee country: {0}': 'Maksunsaajan maa: {0}',
  'Payment amount: {0}': 'Maksun summa: {0}',
  'Message or reference number in the payment: {0}': 'Viesti tai viitenumero maksussa: {0}',
  'Payment is initiated by {0}.': 'Maksun suorittaa {0}.',
  'After you complete authentication, your payment consent will be requested by your account servicing payment service provider.': 'Kun olet suorittanut todennuksen, tiliäsi ylläpitävä maksupalveluntarjoaja pyytää maksusuostumustasi.',
  'terms of service': 'käyttöehdot',
  'Press {0} button if you are not willing to complete this payment.': 'Paina {0} painiketta jos et halua suorittaa tätä maksua.',
  'Select Payment Account': 'Valitse maksutili',
  'Confirm': 'Vahvistaa',
  // Backend messages
  '10 digit client number': '10-numeroinen asiakasnumero',
  '10 digit organisation number (or 12 digit personal number if the company is a sole proprietorship)': '10-numeroinen organisaationumero (tai 12-numeroinen henkilötunnus, jos yritys on yksityinen elinkeinonharjoittaja)',
  '10 digit organization number.': '10-numeroinen organisaation numero.',
  '17 digit card number (starting with 6703)': '17-numeroinen kortin numero (alkaen numerosta 6703)',
  '6 digit Handelsbanken customer number': '6-numeroinen Handelsbankenin asiakasnumero',
  '8 digits CVR number': '8-numeroinen CVR-numero',
  '9 digits Organisasjonsnummer': '9 numeroa Organisasjonsnummer',
  'Agreement number': 'Sopimusnumero',
  'Agreement number for Nordea Corporate Netbank': 'Nordea Corporate Netbank sopimuksen numero',
  'Bank user ID': 'Pankin käyttäjätunnus',
  'Business identity code (Y-tunnus) in 1234567-8 format': 'Yritystunnus (Y-tunnus) muodossa 1234567-8',
  'Business identity code which is displayed in the Corporate Internet bank settings': 'Yritystunnus, joka näkyy yrityksen Internet-pankin asetuksissa',
  'Client ID': 'Asiakastunnus',
  'Client number': 'Asiakasnumero',
  'Company ID': 'Y-tunnus',
  'Company number': 'Yrityksen numero',
  'Corporate ID': 'Yritystunnus',
  'Corporate registration ID': 'Yrityksen rekisteröintitunnus',
  'Currency code': 'Valuutta koodi',
  'Digit card number': 'Numerokortin numero',
  'Disposer': 'Hävittäjä',
  'E-mail': 'Sähköposti',
  'E-mail used for authenticating to Holvi': 'Sähköposti, jota käytetään todentamiseen Holville',
  'Either the 14 digit SEB identifier for the company or the 10 digit organization number': 'Joko yrityksen 14-numeroinen SEB-tunnus tai 10-numeroinen organisaation numero',
  'FKDN (without subaccount number): 3 digit branch number + 7 digit customer number': 'FKDN (ilman alatilinumeroa): 3-numeroinen konttorin numero + 7-numeroinen asiakasnumero',
  'For Swedish Corporates, this is their Organisation number or SHB number, and for Sole Traders (Enskild firma), it is their Personal number, all of which are 10 digits.': 'Ruotsalaisille yrityksille tämä on organisaation numero tai SHB-numero, ja yksinyrittäjille (Enskild firma) henkilökohtainen numero, jotka kaikki ovat 10 numeroa.',
  'IBAN': 'IBAN',
  'ID, NIE, Passport': 'ID, NIE, passi',
  'Login ID used in MyBRD aplications': 'MyBRD-sovelluksissa käytetty kirjautumistunnus',
  'Login Name': 'Kirjautumisnimi',
  'Mandate ID': 'Toimeksiantotunnus',
  'Norwegian national identity number in the format DDMMYYXXXXX (11 digits)': 'Norjan kansallinen henkilötunnus muodossa DDMMYYXXXXX (11 numeroa)',
  'Online banking PIN': 'Verkkopankin PIN-koodi',
  'Online banking Password': 'Verkkopankin salasana',
  'Organisation ID in the format TBxxxxx or TXxxxxx': 'Organisaation tunnus muodossa TBxxxxx tai TXxxxxx',
  'Organisation number': 'Organisaation numero',
  'PIN': 'PIN-koodi',
  'Password': 'Salasana',
  'Password for Aktia Internet bank': 'Salasana Aktian Internet-pankille',
  'Password used for authenticating to Holvi': 'Salasana, jota käytetään todentamiseen Holville',
  'Personal ID': 'Henkilötunnus',
  'Personal ID number': 'Henkilötunnus',
  'Personal code': 'Henkilökohtainen koodi',
  'Personal code of the user': 'Käyttäjän henkilökohtainen koodi',
  'Personal signatory number': 'Henkilökohtainen allekirjoitusnumero',
  'Personal username for online banking': 'Henkilökohtainen käyttäjätunnus verkkopankkiin',
  'Postbank ID': 'Postbank tunnus',
  'Social security number (Personnummer)': 'Sosiaaliturvatunnus (Personnummer)',
  'Social security number in the format YYYYMMDDXXXX': 'Sosiaaliturvatunnus muodossa VVVVKKPPXXXX',
  'Swedish social security number in the format YYYYMMDDXXXX': 'Ruotsalainen henkilötunnus muodossa VVVVKKPPXXXX',
  'The IBAN of the user authenticating': 'Todennuksen suorittavan käyttäjän IBAN',
  'The currency code': 'Valuuttakoodi',
  'The user ID of the user authenticating': 'Todennusta tekevän käyttäjän käyttäjätunnus',
  'Unique personal ID number': 'Ainutlaatuinen henkilötunnus',
  'User ID': 'Käyttäjätunnus',
  'User ID for Aktia Internet bank': 'Käyttäjätunnus Aktian Internet-pankille',
  'User ID for Nordea Corporate Netbank': 'Nordea Corporate Netbank käyttäjätunnus',
  'User ID for online banking': 'Verkkopankki käyttäjätunnus',
  'User ID in the format XX000000': 'Käyttäjätunnus muodossa XX000000',
  'User ID used to log in to the bank': 'Pankkiin kirjautumiseen käytetty käyttäjätunnus',
  'Username': 'Käyttäjätunnus',
  'Username used to log in to the bank': 'Pankkiin kirjautumiseen käytetty käyttäjätunnus',
  'VR NetKey': 'VR NetKey',
  'WebSSO user name': 'WebSSO-käyttäjänimi',
}
